import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.163 8.409c2.696.423 5.324-1.262 6.043-3.966l-1.45-.386c-.559 2.103-2.7 3.342-4.776 2.781l-.559-.15-4.38 7.644c-.287.5-.69.921-1.173 1.228m6.295-7.151l-3.821 6.67a5.03 5.03 0 01-1.671 1.748c-.315.2-.16.673.188.673h1.518c.784 0 1.557-.208 2.237-.604l7.865-4.574a2.069 2.069 0 00.746-2.813l-1.51-2.637 1.301-.746 1.51 2.636a3.57 3.57 0 01-1.293 4.857l-7.865 4.574A5.954 5.954 0 017.377 19H5.859c-1.874 0-2.555-2.45-.991-3.44",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.978-.026.504.104.966.414 1.131.56.298 1.132-.32 1.467-.762L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.872 13.976c-.789-.088-.836-1.147-.826-1.476-.099.454-.197.909-.22 1.354-.037.7.143 1.34.573 1.568.775.412 1.567-.443 2.032-1.056l4.315-5.702-4.777 4.745c-.402.396-.79.598-1.097.566z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.871 7.103A7.259 7.259 0 0019 1.811l-1.932-.518a5.258 5.258 0 01-6.44 3.717l-.742-.199-5.889 10.204a4.742 4.742 0 01-1.58 1.641c-2.114 1.33-1.17 4.594 1.326 4.594h2.042c1.41 0 2.796-.371 4.017-1.076l10.58-6.11a4.75 4.75 0 001.739-6.488l-2.032-3.52-1.732 1 2.032 3.52a2.75 2.75 0 01-1.007 3.757l-10.58 6.109a6.039 6.039 0 01-3.017.808H3.742a.488.488 0 01-.26-.9 6.74 6.74 0 002.246-2.334l5.143-8.913z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.744 27.951c-1.578-.174-1.672-2.292-1.652-2.95-.198.908-.394 1.816-.44 2.708-.074 1.398.286 2.678 1.146 3.134 1.55.826 3.134-.884 4.064-2.112l8.63-11.402-9.554 9.488c-.804.792-1.582 1.196-2.194 1.134z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.743 14.207c7.239 1.136 14.314-3.35 16.254-10.586l-3.863-1.036c-1.504 5.61-7.27 8.939-12.88 7.435l-1.483-.398L7.99 30.031a9.479 9.479 0 01-3.159 3.282c-4.227 2.659-2.34 9.186 2.651 9.186h4.085a16.08 16.08 0 008.033-2.151l21.163-12.219c4.54-2.623 6.1-8.433 3.475-12.976l-4.063-7.041-3.465 2 4.064 7.041v.001a5.499 5.499 0 01-2.012 7.512l-21.16 12.217a12.078 12.078 0 01-6.034 1.616H7.483c-.983 0-1.349-1.28-.52-1.8a13.48 13.48 0 004.492-4.667l10.288-17.825z",
    clipRule: "evenodd"
  }))
};
export var ShoeStroke = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});